var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRivicqMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "RivicQ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 31,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 32,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 32,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 32,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 32,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 16,
    width: 31,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 30,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 30,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 29,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    width: 26,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 25,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 11,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 26,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 13,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 31,
    width: 15,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 15,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 13,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 34,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35,
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 35,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36,
    width: 15,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 38,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 39,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 39,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 42,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 44,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 45,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 48,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 50,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 51,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 52,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 53,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 54,
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 55,
    width: 20,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivicqMark);
export default __webpack_public_path__ + "static/media/rivicq-mark.f330b027e4d0b2c3ba541ca713cc6288.svg";
export { ForwardRef as ReactComponent };